import Head from 'next/head';
import { ToolTip } from '@/components/ToolTip';
import Script from 'next/script';

const Page = () => {
  return (
    <>
      <Head>
        <title>Tooltip</title>
      </Head>

      <h1>Tooltip</h1>

      <ToolTip />
      <Script id="tooltip">
        {`          
          var tooltipTriggerList = [].slice.call(
            document.querySelectorAll('[data-bs-toggle="tooltip"]')
          );

          var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl)
          });
        `}
      </Script>
    </>
  );
};

export default Page;
